import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import t from '@instructure/quiz-i18n/es/format-message';
import { Button } from '@instructure/ui-buttons';
import { Heading } from '@instructure/ui-heading';
import { Tooltip } from '@instructure/ui-tooltip';
import { AccessibleContent } from '@instructure/ui-a11y-content';
export var ResetQuiz = /*#__PURE__*/function (_Component) {
  function ResetQuiz() {
    var _this;
    _classCallCheck(this, ResetQuiz);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, ResetQuiz, [].concat(args));
    _defineProperty(_this, "focusReopenButton", function () {
      _this.reopenButtonRef && _this.reopenButtonRef.focus();
    });
    _defineProperty(_this, "reopenQuizSession", function () {
      _this.props.withConfirm(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.props.reopenQuizSession(_this.props.sessionId);
            case 2:
              _this.props.trayResetFocus();
              _this.props.screenreaderNotification(t("The student's attempt has been reopened"));
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      })), {
        onCancel: _this.focusReopenButton,
        shouldReturnFocus: false,
        // manually handling return focus instead
        title: t('Reopen Latest Attempt'),
        continueText: t('Reopen'),
        text: t("Reopening the most recent attempt allows the student to resume their assessment.\n        Previously recorded responses will be retained and the timer,\n        if applicable, will continue with the remaining time.")
      });
    });
    _defineProperty(_this, "reopenButtonRef", function (node) {
      _this.reopenButtonRef = node;
    });
    return _this;
  }
  _inherits(ResetQuiz, _Component);
  return _createClass(ResetQuiz, [{
    key: "render",
    value: function render() {
      if (!this.props.reopenOn) return null;
      var _this$props = this.props,
        reopenOverride = _this$props.reopenOverride,
        sessionId = _this$props.sessionId;
      if (!sessionId) {
        return /*#__PURE__*/React.createElement("span", null, t('No attempts have been recorded yet.'));
      }
      var reOpen = /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Heading, {
        level: "h3"
      }, t('Manage current attempt')), this.props.reopenOn ? /*#__PURE__*/React.createElement(Button, {
        ref: this.reopenButtonRef,
        onClick: this.reopenQuizSession,
        disabled: !this.props.isComplete || reopenOverride,
        margin: "small none",
        "data-automation": "sdk-reopen-quiz-button"
      }, t('Reopen')) : null);
      if (reopenOverride) {
        var text = t('One Question at Time Quizzes with Backtracking disabled cannot be reopened.');
        return /*#__PURE__*/React.createElement(AccessibleContent, {
          alt: text
        }, /*#__PURE__*/React.createElement(Tooltip, {
          renderTip: text,
          placement: "start"
        }, reOpen));
      }
      return reOpen;
    }
  }]);
}(Component);
_defineProperty(ResetQuiz, "propTypes", {
  sessionId: PropTypes.string.isRequired,
  isComplete: PropTypes.bool.isRequired,
  trayResetFocus: PropTypes.func.isRequired,
  reopenQuizSession: PropTypes.func.isRequired,
  reopenOn: PropTypes.bool.isRequired,
  screenreaderNotification: PropTypes.func.isRequired,
  withConfirm: PropTypes.func.isRequired,
  reopenOverride: PropTypes.bool.isRequired
});
export default ResetQuiz;